<button
  (click)="openConfig.emit()"
  class="config-panel-toggle"
  color="primary"
  mat-mini-fab
  type="button">
  <mat-icon svgIcon="mat:settings"></mat-icon>
</button>
